import { render } from "./SVGColorFloor.vue?vue&type=template&id=017fc67c"
import script from "./SVGColorFloor.vue?vue&type=script&lang=js"
export * from "./SVGColorFloor.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__